export default __webpack_public_path__ + "static/media/element_spec_98.6f40095d.webp";